"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accessToken = accessToken;
exports.authCallback = authCallback;
exports.deleteAllianceConfig = deleteAllianceConfig;
exports.genOauthUrl = genOauthUrl;
exports.getAllianceConfig = getAllianceConfig;
exports.get_mt_config = get_mt_config;
exports.listBasePaged = listBasePaged;
exports.loadBase = loadBase;
exports.loadConfig = loadConfig;
exports.loadFeeRate = loadFeeRate;
exports.loadOauthUrl = loadOauthUrl;
exports.removeBase = removeBase;
exports.saveAllianceConfig = saveAllianceConfig;
exports.saveBase = saveBase;
exports.saveConfig = saveConfig;
exports.saveFeeRate = saveFeeRate;
exports.saveOauth = saveOauth;
exports.save_mt_config = save_mt_config;
exports.setActive = setActive;
exports.setDefaultConfig = setDefaultConfig;
exports.updateAllianceConfig = updateAllianceConfig;
var _request = _interopRequireDefault(require("@/utils/request"));
function saveAllianceConfig(data) {
  return (0, _request.default)({
    url: "/portal/system/allianceConfig/saveAllianceConfig",
    method: "post",
    data: data
  });
}
function getAllianceConfig(data) {
  return (0, _request.default)({
    url: "/portal/system/allianceConfig/getAllianceConfig",
    method: "post",
    data: data
  });
}
function deleteAllianceConfig(data) {
  return (0, _request.default)({
    url: "/portal/system/allianceConfig/deleteAllianceConfig",
    method: "post",
    data: data
  });
}
function updateAllianceConfig(data) {
  return (0, _request.default)({
    url: "/portal/system/allianceConfig/updateAllianceConfig",
    method: "post",
    data: data
  });
}
function setDefaultConfig(data) {
  return (0, _request.default)({
    url: "/portal/system/allianceConfig/setDefaultConfig",
    method: "post",
    data: data
  });
}
function accessToken(data) {
  return (0, _request.default)({
    url: "/portal/system/allianceConfig/accessToken",
    method: "post",
    data: data
  });
}
// --------------------------------------------------------------------------------------
// 查询联盟配置
function loadConfig(params) {
  return (0, _request.default)({
    url: "/portal/system/union/loadConfig",
    method: "get",
    params: params
  });
}
// 查询联盟配置
function loadFeeRate(params) {
  return (0, _request.default)({
    url: "/portal/system/union/loadFeeRate",
    method: "get",
    params: params
  });
}
// 保存联盟配置
function saveConfig(data) {
  return (0, _request.default)({
    url: "/portal/system/union/saveConfig",
    method: "post",
    data: data
  });
}
// 修改服务费比例
function saveFeeRate(data) {
  return (0, _request.default)({
    url: "/portal/system/union/saveFeeRate",
    method: "post",
    data: data
  });
}
// ----------------------------------------
function genOauthUrl(params) {
  return (0, _request.default)({
    url: "/portal/system/union/genOauthUrl",
    method: "get",
    params: params
  });
}
function authCallback(data) {
  return (0, _request.default)({
    url: "/portal/system/union/authCallback",
    method: "post",
    data: data
  });
}

// 保存联盟账号基础信息
function saveBase(data) {
  return (0, _request.default)({
    url: "/portal/system/union/saveBase",
    method: "post",
    data: data
  });
}

// 分页查询基础配置
function listBasePaged(params) {
  return (0, _request.default)({
    url: "/portal/system/union/listBasePaged",
    method: "get",
    params: params
  });
}
// 删除联盟账号基础信息
function removeBase(data) {
  return (0, _request.default)({
    url: "/portal/system/union/removeBase",
    method: "post",
    data: data
  });
}
// 查询联盟账号基础信息
function loadBase(params) {
  return (0, _request.default)({
    url: "/portal/system/union/loadBase",
    method: "get",
    params: params
  });
}
// 设置默认联盟账号
function setActive(data) {
  return (0, _request.default)({
    url: "/portal/system/union/setActive",
    method: "post",
    data: data
  });
}
// 获取授权页面
function loadOauthUrl(params) {
  return (0, _request.default)({
    url: "/portal/system/union/loadOauthUrl",
    method: "get",
    params: params
  });
}
// 保存授权
function saveOauth(data) {
  return (0, _request.default)({
    url: "/portal/system/union/saveOauth",
    method: "post",
    data: data
  });
}
function get_mt_config(params) {
  return (0, _request.default)({
    url: "/portal/system/union/baseconfig",
    method: "get",
    params: params
  });
}
function save_mt_config(data) {
  return (0, _request.default)({
    url: "/portal/system/union/baseconfig",
    method: "post",
    data: data
  });
}